(function () {
  function initVideoState(root) {
    root.querySelectorAll('.agld-vid').forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;

      video.addEventListener('play', function () {
        card.classList.add('agld-playing');
      });
      video.addEventListener('pause', function () {
        card.classList.remove('agld-playing');
      });
      video.addEventListener('ended', function () {
        card.classList.remove('agld-playing');
      });
    });
  }

  function init() {
    document.querySelectorAll('.agld').forEach(initVideoState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
